export function validateEmail(email: string): boolean {
    return !email || email.length > 5 && email.includes("@") && email.includes(".");
}
